import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './KioskConsultLayout.styles';
import {
  KioskFooter,
  KioskHeader,
  KioskConsultMain,
  KioskSideSlides
} from '..';

export class KioskConsultLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: 'Step 4 :',
    pageTitle: 'You have questions, we have answers'
  };

  render() {
    const { classes } = this.props;
    var customFooterBottom;
    if (window.screen.width >= 1440) {
      customFooterBottom = '-25%';
    } else {
      customFooterBottom = '0%';
    }
    return (
      <div className={classNames(classes.container)}>
        <KioskHeader />
        <KioskSideSlides
          stepTitle={this.state.stepTitle}
          pageTitle={this.state.pageTitle}
          customHeight={120}
        />
        <KioskConsultMain />
        <KioskFooter customFooterBottom={customFooterBottom} />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(KioskConsultLayout);
